import { useState } from "react";
import { Select } from "../../SharedModule/components/Select";
import { useDispatch } from "react-redux";
import { MdArrowRightAlt } from "react-icons/md";
import { ClientContact } from "../types/clients-module-types";
import {
  setContact,
  setIsLoadingActualKeyContactData,
} from "../redux/reducers/clientKeyContacts.reducer";
import { Link, useLocation, useNavigate } from "react-router";
import {
  ROUTE_CLIENTS_CONTACTS,
  ROUTE_CLIENTS_RELATIONSHIP_NEW_KEY_CONTACT_DETAILS,
  ROUTE_CLIENTS_RELATIONSHIP_REVIEW,
} from "../../SharedModule/utils/constants";

export const ModalAddNewKeyContact = ({
  btnCancel,
  companyId,
  relationshipReviewId,
  isLoadingContacts,
  clientContactsInfo,
  keyContactList,
}: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [formTouched, setFormTouched] = useState(false);

  let keyContactAlreadyAdded: number[] = keyContactList.map(
    (kc) => kc.contactId
  );

  let clientsToShow: any[] = [...clientContactsInfo]
    .filter((item) => !keyContactAlreadyAdded.includes(item.id) && item.isActive)
    .sort((a, b) =>
      a.lastName.toLowerCase().localeCompare(b.lastName.toLowerCase())
    )
    .map((client: ClientContact) => ({
      value: client.id,
      label: `${client.lastName}, ${client.firstName}`,
    }));

  const handleChange = (value: any) => {
    setFormTouched(true);
    setKeyContact(value);
  };

  const [keyContact, setKeyContact] = useState({
    value: "0",
    label: "-- Select Name --",
  });

  const handleAddNewKeyContact = () => {
    let contactSelected = clientContactsInfo.find(
      (client) => client.id === keyContact.value
    );
    // this only set on add, then should be cleaned
    dispatch(setContact({ contact: contactSelected }));
    navigate(
      ROUTE_CLIENTS_RELATIONSHIP_NEW_KEY_CONTACT_DETAILS.replace(
        ":id",
        companyId
      ).replace(":relationshipReviewId", relationshipReviewId),
      {
        state: {
          from:
            location.state?.from === ROUTE_CLIENTS_RELATIONSHIP_REVIEW
              ? ROUTE_CLIENTS_RELATIONSHIP_REVIEW
              : "",
        },
      }
    );
    dispatch(setIsLoadingActualKeyContactData(false));
    btnCancel();
  };

  return (
    <>
      <h4 className="text-center text-capitalize">Add New Key Contact</h4>
      <hr className="w-100" />

      <div className="d-flex flex-column my-4">
        <h6 style={{ fontWeight: "bold" }}>Contact Details</h6>
        <div>
          If you can't find the contact you're looking for,
          <Link
            className="link-text ms-1"
            to={ROUTE_CLIENTS_CONTACTS.replace(":id", companyId)}
          >
            add it to the Client first.
            <MdArrowRightAlt />
          </Link>
        </div>
      </div>

      <div className="d-flex mt-2 flex-column mb-2">
        <div className="d-flex justify-content-between">
          <div className="position-relative w-100">
            <label
              className="form-label gray-label"
              htmlFor="key-contact-select"
            >
              FULL NAME
            </label>
            <Select
              id="key-contact-select"
              placeholder="Select Name"
              className="mb-2"
              options={clientsToShow}
              isLoading={isLoadingContacts}
              value={keyContact}
              onChange={(kc) => handleChange(kc)}
            />
          </div>
        </div>
      </div>

      <hr className="w-100" />
      <div className="d-flex mt-2">
        <button
          className="btn button-secondary w-100"
          onClick={() => btnCancel()}
        >
          Cancel
        </button>
        <button
          className="btn btn-primary ms-2 w-100"
          disabled={!formTouched}
          onClick={() => handleAddNewKeyContact()}
        >
          Add
        </button>
      </div>
    </>
  );
};
